import axios from "../axiosClient";

export interface AnalyticsPayload {
  assetCodes: string[];
  date: string;
  chartType: number;
}

export const getAnalyticMotionData = async (
  payload: AnalyticsPayload,
  signal?: AbortSignal,
) => {
  const res = await axios.post(`/slpapp/Asset/getAnalyticMotionData`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
    signal,
  });

  return res?.data;
};

export const getAnalyticDaylightData = async (
  payload: AnalyticsPayload,
  signal?: AbortSignal,
) => {
  const res = await axios.post(
    `/slpapp/Asset/getAnalyticDaylightData`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
      signal,
    },
  );

  return res?.data;
};

export const getAnalyticLightOPStatusData = async (
  payload: AnalyticsPayload,
  signal?: AbortSignal,
) => {
  const res = await axios.post(
    `/slpapp/Asset/getAnalyticLightOPStatusData`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
      signal,
    },
  );

  return res?.data;
};
